const mobileClass = '--mobile';
const tabletClass = '--tablet';
const desktopClass = '--desktop';

function getViewportType() {
  const width = window.innerWidth;

  if (width <= 768) {
    return mobileClass;
  }

  if (width <= 1024) {
    return tabletClass;
  }

  return desktopClass;
}

function setViewportClass(viewportClass) {
  const root = document.documentElement;

  root.classList.toggle(mobileClass, viewportClass === mobileClass);
  root.classList.toggle(tabletClass, viewportClass === tabletClass);
  root.classList.toggle(desktopClass, viewportClass === desktopClass);
}

export function initViewportClass() {
  const updateViewportClass = () => {
    setViewportClass(getViewportType());
  };

  updateViewportClass();
  window.addEventListener('resize', updateViewportClass);
}
